<template>
  <div class="uniqueList">
    <breadcrumb class="bread" :path="path" :name="name" :childPath="childPath" :childName="childName"
                :childPathThree="childPathThree" :childNameThree="childNameThree"></breadcrumb>
    <div class="main-row contain">
      <div class="col col-xlg-12 col-sm-12 uniqueList-item">
        <div class="searchStyle">
          <div style="width: 60%;">
            <el-form :inline="true" :model="searchForm" label-position="top">
              <el-form-item label="科中文名" prop="sectionChinese">
                <el-input v-model="searchForm.sectionChinese" placeholder="科中文名"/>
              </el-form-item>
              <el-form-item label="科拉丁名" prop="sectionLatin">
                <el-input v-model="searchForm.sectionLatin" placeholder="科拉丁名"/>
              </el-form-item>
              <el-form-item label="学名" prop="scientificName">
                <el-input v-model="searchForm.scientificName" placeholder="学名"/>
              </el-form-item>
              <el-form-item label="分布" prop="distribution">
                <el-input v-model="searchForm.distribution" placeholder="分布"/>
              </el-form-item>
              <div style="display: inline-block" class="button">
                <el-button type="primary" @click="onSubmit">查询</el-button>
                <el-button type="primary" @click="backSubmit">返回</el-button>
              </div>
            </el-form>
          </div>
          <div style="width: 60%;font-size: 13px;padding-left: 8px;text-align: left">
            <p style="padding: 10px 0"><span style="font-weight: 700">参考资料：</span>高黎贡山植物资源与区系地理. 李恒，李嵘主编. --武汉：湖北科学技术出版社, 2020.12</p>

          </div>
        </div>
        <template >
          <el-table border style="width: 100%" :row-style="{height: '8px'}"
                    :cell-style="{padding:'0px'}" :header-cell-style="{backgroundColor: '#eee',color: '#333'}" :data="tableData">
            <el-table-column type="index" header-align="center" align="left" label="序号" width="80">
              <template slot-scope="scope">
                <span>{{ (pageIndex - 1) * pageSize + scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sectionChinese" header-align="center" align="left" label="科中文名"  show-overflow-tooltip/>
            <el-table-column prop="sectionLatin" header-align="center" align="left" label="科拉丁名" show-overflow-tooltip/>
            <el-table-column prop="chineseName" header-align="center" align="left" label="中文名" show-overflow-tooltip/>
            <el-table-column prop="scientificName" header-align="center" align="left" label="学名" show-overflow-tooltip/>
            <el-table-column prop="distribution" header-align="center" align="left" label="分布"  show-overflow-tooltip/>
            <el-table-column prop="habitat" header-align="center" align="left" label="生境"  show-overflow-tooltip/>
            <el-table-column prop="note" header-align="center" align="left" label="备注"  show-overflow-tooltip/>
            <el-table-column prop="document" header-align="center" align="left" label="文献"  show-overflow-tooltip/>
            <el-table-column header-align="center" align="left" label="操作" fixed="right" width="120">
              <template slot-scope="scope">
                <el-button  type="text" @click="toTableDetail(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="pagin" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="pageIndex" :page-size="pageSize" :page-sizes="[25,50,75,100]" layout="total, sizes, prev, pager, next" :total="total"></el-pagination>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb'
import { fetchList } from '../../../network/gaoligongdirectory/endemicPlant'

export default {
  name: "uniqueList",
  components: { breadcrumb },
  data() {
    return {
    path: '',
    name: '',
      childName:'',
      childPath:'',
      childPathThree: '',
      childNameThree: '',
      tableData: [],
      type: 'specificPlantDirectory',
      pageIndex: 1,
      pageSize: 25,
      searchForm: {},
      total: 0,

    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.path = from.path
      vm.name = '资源'
    })
  },
  mounted() {
    this.getList()
    this.$nextTick(() => {

    })
  },

  created() {
    this.childPathThree=this.$route.path
    this.childNameThree = this.$route.name
    this.childName = '名录'
    this.childPath = this.$route.path
  },
  methods:{
    getList() {
      fetchList(Object.assign({
        page: this.pageIndex,
        pageSize: this.pageSize,
        // type: this.type
      }, this.searchForm)).then(res => {
        this.tableData = res.data.data.specificPlantDirectoryList
        this.total = res.data.data.total
      })
    },
    handleSizeChange(val){
      this.pageSize = val
      this.page = 1
      this.getList()

    },
    handleCurrentChange(val){
      this.page = val
      this.getList()
    },
    toTableDetail(row) {
      this.$router.push({
        path: '/tableDetail',
        query: {
          id: row.id,
          formName: this.type,
          name: '高黎贡山特有植物名录'
        }
      })
    },
    onSubmit() {
      this.page = 1
      this.getList()
    },
    backSubmit() {
      this.page = 1
      this.searchForm = {}
      this.getList()
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/uniqueList";
::v-deep .el-pagination {
  padding: 20px 5px !important;
  text-align: center;
}
</style>